/* eslint-disable linebreak-style */
// eslint-disable-next-line linebreak-style
/* eslint-disable max-len */
/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Paper, Button } from '@material-ui/core';
import { Group, ArrowForward } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import PresenceGraph from '../../../components/Graphics/PresenceGraph';

class WorkActivityChartAll extends React.Component {
  state = {
    defaultList: [],
    workActivityData: [],
    workActivityInfo: null,
    selectedSlice: null,
  };

  componentDidMount() {
    if (this.props.data) {
      this.fetchPresences();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.department !== this.props.department || prevProps.data !== this.props.data) {
      this.fetchPresences();
    }
  }

  setPieConfig = (list) => {
    let workActivityFinished = 0;
    let workActivityInProgess = 0;

    list.forEach((workActivityData) => {
      if (workActivityData.inParentId != null) {
        workActivityFinished += 1;
      } else {
        workActivityInProgess += 1;
      }
    });

    const infoConfig = [
      {
        id: 'Finalizadas', label: 'Finalizadas', value: workActivityFinished, color: '#7BC6F1',
      },
      {
        id: 'Em andamento', label: 'Em andamento', value: workActivityInProgess, color: '#887BF1',
      }
    ];

    return infoConfig;
  }

  fetchPresences = () => {
    const response = this.props.data;
    let workActivityList = [];

    if (response && response.length > 0) {
      workActivityList = response.filter(i => ({
        inParentId: i.inParentId
      }));
    }

    this.setState({
      defaultList: [...workActivityList],
      workActivityData: workActivityList,
      workActivityInfo: this.setPieConfig(workActivityList),
      selectedSlice: null,
    });
  }

  render() {

    const { onClickSlice, history } = this.props;

    return (
      <></>
      // <Grid>
      //   <Paper elevation={2} style={{ flexBasis: '40%', margin: 'auto', marginTop: 'initial' }} data-tut="reactour__Faltantes">
      //     <Typography
      //       variant="h6"
      //       component="h4"
      //       color="textSecondary"
      //       align="left"
      //       style={{ padding: 20, fontColor: '#8898AA', fontSize: 15 }}
      //     >
      //       {' Resumo dos Serviços '}
      //     </Typography>

      //     <div
      //       style={{
      //         height: 300,
      //         //minWidth: 300,
      //         padding: '10px',
      //         alignItems: 'center',
      //         display: 'flex',
      //         justifyContent: 'center',
      //         cursor: !this.state.workActivityData.length ? 'default' : 'pointer',
      //       }}
      //     >
      //       {
      //         !this.state.workActivityData.length ? (
      //           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      //             <Group color="disabled" style={{ fontSize: 100, paddingBottom: 20 }} />
      //             <Typography component="h3" color="textSecondary" align="center">
      //               Nenhum resumo de servicos a ser exibido
      //             </Typography>
      //           </div>
      //         ) :
      //           <PresenceGraph data={this.state.workActivityInfo} />
      //       }
      //     </div>
      //   </Paper>
      //   <Paper style={{ display: 'flex', justifyContent: 'center' }}>
      //     <Button
      //       style={{ /*left: '280px', width: '100%',*/ height: '47px', width: '100%' }}
      //       component={Link}
      //       to="/central-de-servicos"
      //     >
      //       <Typography
      //         style={{
      //           textTransform: 'none',
      //           color: '#537ccd',
      //           marginRight: '2px',
      //           fontSize: '15px',
      //           fontWeight: 400,
      //         }}>Ir para tela completa</Typography>
      //       <ArrowForward style={{ opacity: '0.6' }} />
      //     </Button>
      //   </Paper>
      // </Grid >
    );
  }
}

export default WorkActivityChartAll; 